<template>
  <div class="teachers">
    <div class="container content" v-loading="loading">
      <el-row class="teacher-list" :gutter="40">
        <el-col :sm="12" v-for="(item, index) in teachers" :key="index">
          <div class="teacher-item card-shadow has-hover hover-bigger" @click="viewTeacher(item)">
            <el-image class="cover" fit="cover" :src="item.pic"></el-image>
            <div class="teacher-info">
              <h1>{{ item.name }}</h1>
              <div class="school pc">{{ item.job }}</div>
              <div class="introduction">{{ item.spokenWords }}</div>
              <el-button class="view-btn pc" type="warning" round>查看专栏</el-button>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="empty-tip" v-if="teachers.length === 0">-暂无数据-</div>
    </div>
  </div>
</template>

<script>
import { teachers } from "@/api/api.js";

export default {
  name: "teachers",
  data() {
    return {
      site: "",
      teachers: [],
      loading: false
    };
  },
  created() {
    this.site = (this.$route.path).split("/")[1];
    this.loading = true;
    teachers({
      websiteId: 5,
      pageSize: 999,
      pageNum: 1
    })
      .then(res => {
        // 返回数据
        this.teachers = res.list;

        this.loading = false;
      })
      .catch(err => {
        // 异常情况
        console.log(err);
        this.loading = false;
      });
  },
  methods: {
    viewTeacher(item) {
       window.open(`#/${this.site}/teacherContent/${item.domain}`);
    }
  }
};
</script>

<style scoped>
.content {
  margin-top: 0;
  margin-bottom: 80px;
}

.teacher-item {
  position: relative;
  margin-top: 40px;
  padding: 30px;
  background-color: #fff;
  background-image: url("~@/assets/images/hnkc/teacher-background.png");
  background-repeat: no-repeat;
  background-position: top right;
  cursor: pointer;
}

.teacher-item .cover {
  position: absolute;
  width: 160px;
  height: 240px;
  background-color: #eee;
}

.teacher-item .teacher-info {
  min-height: 240px;
  padding-left: 190px;
}

.teacher-item h1 {
  font-size: 20px;
  height: 24px;
  line-height: 24px;
  color: #444;
  overflow: hidden;
}

.teacher-item .school {
  margin-top: 8px;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  font-weight: bold;
  overflow: hidden;
}

.teacher-item .introduction {
  margin-top: 18px;
  margin-bottom: 10px;
  height: 110px;
  line-height: 22px;
  font-size: 14px;
  color: #888;
  overflow: hidden;
}

.view-btn {
  width: 160px;
  border: none;
  background-image: none;
  background-color: #7691ff;
}

@media (max-width: 767px) {
  .content {
    margin-top: 0;
    margin-bottom: 0;
    padding-bottom: 30px;
    background-color: #f8f8f8;
  }

  .teacher-list {
    margin-top: 0;
  }

  .teacher-item {
    margin-top: 15px;
    padding: 0;
    background-image: unset;
  }

  .teacher-item .cover {
    width: 100px;
    height: 100px;
  }

  .teacher-item .teacher-info {
    min-height: 94px;
    padding-left: 110px;
    padding-top: 6px;
    padding-right: 10px;
  }

  .teacher-item h1 {
    font-size: 16px;
    height: 22px;
    line-height: 22px;
  }

  .teacher-item .introduction {
    margin-top: 20px;
    margin-bottom: 0;
    height: 36px;
    line-height: 18px;
    font-size: 12px;
    color: #444;
  }
}
</style>
